<template>
   <div>
      <div class="row">
         <breadcrumb>
            <template v-slot:1>
               <router-link :to="{ name: 'informes' }">{{
                  $t("informes")
               }}</router-link>
            </template>
            <template v-slot:2>
               {{ $t("gestionTurnos") }}
            </template>
         </breadcrumb>
         <div class="col-md-12">
            <div class="card">
               <div class="row">

                  <div class="col-md-2">
                     <div class="form-group">
                        <label>{{ $t("fechaInicio") }}</label>
                        <datetime value-zone="Europe/Madrid" :auto="true" class="theme-numier" format="dd-MM-yyyy"
                           :title="$t('fechaInicio')" :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                           input-class="form-control" v-model="datefrom"></datetime>
                     </div>
                  </div>

                  <div class="col-md-2">
                     <div class="form-group">
                        <label>{{ $t("fechaFin") }}</label>
                        <datetime value-zone="Europe/Madrid" :auto="true" class="theme-numier" :title="$t('fechaFin')"
                           format="dd-MM-yyyy" :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                           input-class="form-control" v-model="dateto"></datetime>
                     </div>
                  </div>


                  <div class="col-md-2">
                     <label>&nbsp;</label>
                     <div class="form-group">
                        <button class="btn btn-primary" @click="getWorkersShifts()">
                           <i class="fa fa-sync" v-if="loading" style="margin-right: 5px;"></i>
                           {{ $t("consultar") }}
                        </button>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <template v-if="!respuesta || workerDataByUser.length === 0">
            <div class="alert alert-warning m-3" style="width: 100%" role="alert">
               {{ $t('No hay datos de turnos para mostrar.') }}
            </div>
         </template>

         <template v-else="respuesta">
            <div class="col-md-12">

               <template>
                  <div v-if="workerDataByUser.length > 0">
                     <table class="table table-bordered table-striped text-nowrap">
                        <thead class="thead-dark">
                           <tr style="cursor: pointer">
                              <th v-if="ordenarNombre === 0" @click="sortedArrayNombreASC('name')">
                                 <i style="color: white" class="fa fa-angle-up"></i> {{ $t("nombre") }}
                              </th>
                              <th v-else @click="sortedArrayNombreDESC('name')">
                                 <i style="color: white" class="fa fa-angle-down"></i> {{ $t("nombre") }}
                              </th>

                              <th v-if="ordenarHoras === 0" @click="sortedArrayHorasASC('totalSecondsWorked')">
                                 <i style="color: white" class="fa fa-angle-up"></i> {{ $t("horas") }}
                              </th>
                              <th v-else @click="sortedArrayHorasDESC('totalSecondsWorked')">
                                 <i style="color: white" class="fa fa-angle-down"></i> {{ $t("horas") }}
                              </th>

                              <th v-if="ordenarBarcode === 0" @click="sortedArrayBarcodeASC()">
                                 <i style="color: white" class="fa fa-angle-up"></i> {{ $t("dni") }}
                              </th>
                              <th v-else @click="sortedArrayBarcodeDESC()">
                                 <i style="color: white" class="fa fa-angle-down"></i> {{ $t("dni") }}
                              </th>

                              <th>{{ $t("acciones") }}</th>
                           </tr>
                        </thead>
                        <tbody>
                           <tr v-for="worker in workerDataByUser" :key="worker.workerIds.join(',')">
                              <td>{{ worker.name }} {{ worker.surName }}</td>
                              <td>{{ worker.formattedTime }}</td>
                              <td>{{ worker.barCode }}</td>
                              <!--
                              <td align="center">
                                 <div class="btn btn-link" style="cursor: pointer"
                                    v-tooltip.top-center="$t('VerDetalles')"
                                    @click="getDesgloseHorasByWorker(worker.workerId)">
                                    <i class="fa fa-eye text-primary"></i>
                                 /div>
                              </td>
                              -->
                              <td align="center">
                                 <div v-tooltip.top-center="$t('exportarExcel')" class="btn btn-link"
                                    @click="exportGestionTurnosOperariosExcel(worker.workerIds)">
                                    <i class="fas fa-file-excel text-success"></i>
                                 </div>
                              </td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
               </template>
            </div>

            <!-- <div class="col-md-4 " v-show="this.list.length > 0">
               <div class="card">
                  <div class="chart-container col-md-12 " style="height:40vh;">
                     <canvas id="chart"></canvas>
                  </div>
               </div>
            </div> -->
         </template>
      </div>

      <!-- Modal de desglose de horas por trabajador -->
      <modal name="modal-desglose-horas" height="auto" :scrollable="true">
         <div class="p-3">
            <h5>{{ $t("desgloseHoras") }}</h5>
            <table class="table table-bordered table-sm">
               <thead>
                  <tr>
                     <th>{{ $t("horaInicio") }}</th>
                     <th>{{ $t("horaFin") }}</th>
                     <th>{{ $t("horasTrabajadas") }}</th>
                  </tr>
               </thead>
               <tbody>
                  <tr v-for="(item, index) in desgloseHoras" :key="index">
                     <td>{{ formatHora(item.initDate) }}</td>
                     <td>{{ formatHora(item.endDate) }}</td>
                     <td>{{ formatDuracion(item.endDate - item.initDate) }}</td>
                  </tr>
               </tbody>
            </table>
            <button class="btn btn-secondary mt-2" @click="hideDesgloseHoras()">{{ $t("cerrar") }}</button>
         </div>
      </modal>

   </div>
</template>

<script>
// import CabeceraInformes from "@/components/CabeceraInformes/CabeceraInformes.vue";
import Datepicker from "vuejs-datepicker";
import Chart from "chart.js";
import {
   DatePicker,
   Select,
   Option,
   Loading,
   Dropdown,
   DropdownItem,
   DropdownMenu,
   Button,
} from "element-ui";
import swal from "sweetalert2";
import moment from "moment";
import Breadcrumb from "../../../../components/Breadcrumb/Breadcrumb.vue";
import { mapState } from 'vuex'
import { Modal } from "bootstrap";
import { ModalPlugin } from "bootstrap-vue";

export default {

   data() {
      return {
         loading: false,
         datefrom: new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            1
         ).toISOString(),
         dateto: new Date().toISOString(),
         listBusinesses: [],
         value4: [
            new Date(new Date().getFullYear(), new Date().getMonth(), 1),
            new Date(),
         ],
         idBusiness: 0,
         list: ["-"],
         mode: 0,
         $Chart: null,
         objectChart: null,
         contador: 0,
         chartIn: 0,
         listTpv: [],
         idTpv: 0,
         dateRangeOptions1: {
            firstDayOfWeek: 1,
         },

         ordenacionOperario: 0,
         ordenarImporte: 0,
         ordenarInvitations: 0,
         ordenarDifHora: 0,
         ordenarSueldo: 0,

         observacion: "",

         //TURNOS
         mostrarTurnos: false,
         listTurnos: [],
         idWorker: 0,

         idWorkerDay: 0,
         respuesta: true,
         filtrarPorFecha: false,

         fechaInicio: new Date().toISOString(),
         fechaFin: new Date().toISOString(),

         createdDate: new Date().toISOString(),
         expiredDate: new Date(Date.now() + 5 * 60 * 60 * 1000).toISOString(), // +5 horas
         generatedHash: "",

         // ID negocios
         workerDataByUser: [],
         negociosFiltrados: [],
         ordenarNombre: 0,
         ordenarHoras: 0,
         ordenarBarcode: 0,
         desgloseHoras: []
      };
   },
   watch: {
      // workerDataByUser() {
      //    this.$nextTick(() => {
      //       this.initChart();
      //    });
      // }
   },
   computed: {
      urlExportPDF() {
         return (
            this.$store.getters.apiUrl +
            "/workers/exportTurnosWorkers/PDF?idTpv=" +
            this.idTpv +
            "&idBusiness=" +
            this.idBusiness +
            "&datefrom=" +
            moment(this.datefrom)
               .startOf("day")
               .unix() +
            "&dateto=" +
            moment(this.dateto)
               .endOf("day")
               .unix() +
            "&filtrarPorFecha=" +
            this.filtrarPorFecha +
            "&jwt=" +
            this.$store.getters.jwt
         );
      },

      urlExportExcel() {
         return (
            this.$store.getters.apiUrl +
            "/workers/exportTurnosWorkers/Excel?idTpv=" +
            this.idTpv +
            "&idBusiness=" +
            this.idBusiness +
            "&datefrom=" +
            moment(this.datefrom)
               .startOf("day")
               .unix() +
            "&dateto=" +
            moment(this.dateto)
               .endOf("day")
               .unix() +
            "&filtrarPorFecha=" +
            this.filtrarPorFecha +
            "&jwt=" +
            this.$store.getters.jwt
         );
      },

      urlExportPDFById() {
         return (
            this.$store.getters.apiUrl +
            "/workers/exportTurnosWorkersById/PDF?idBusiness=" +
            this.idBusiness +
            "&idTpv=" +
            this.idTpv +
            "&idWorker=" +
            this.idWorker +
            "&datefrom=" +
            moment(this.datefrom)
               .startOf("day")
               .unix() +
            "&dateto=" +
            moment(this.dateto)
               .endOf("day")
               .unix() +
            "&filtrarPorFecha=" +
            this.filtrarPorFecha +
            "&jwt=" +
            this.$store.getters.jwt
         );
      },

      urlExportExcelById() {
         return (
            this.$store.getters.apiUrl +
            "/workers/exportTurnosWorkersById/Excel?idBusiness=" +
            this.idBusiness +
            "&idTpv=" +
            this.idTpv +
            "&idWorker=" +
            this.idWorker +
            "&datefrom=" +
            moment(this.datefrom)
               .startOf("day")
               .unix() +
            "&dateto=" +
            moment(this.dateto)
               .endOf("day")
               .unix() +
            "&filtrarPorFecha=" +
            this.filtrarPorFecha +
            "&jwt=" +
            this.$store.getters.jwt
         );
      },
   },

   created() {
      this.loading = Loading.service({ text: "Cargando..." });

      this.getFichajesPermission();

      if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
         this.datefrom = this.$store.getters.dateFrom;
         this.dateto = this.$store.getters.dateTo;
      }
   },
   components: {
      // CabeceraInformes,
      Breadcrumb,
      [DatePicker.name]: DatePicker,
      [Select.name]: Select,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Button.name]: Button,
      [Option.name]: Option,
   },
   methods: {
      getFichajesPermission() {
        var config = {
          params: {
              jwt: this.$store.getters.jwt
          },
          headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
        };
      let vm = this;
      this.axios.get(this.$store.getters.apiUrl + "turnos/getFichajesPermission", config)
      .then(function (response) {
        if(response.data.result){
          const idBusinessesFichajes = response.data.ids;

         vm.negociosFiltrados  = idBusinessesFichajes;

         vm.getWorkersShifts();

        }else{
          vm.gestionTurnosOperarios = false;
          vm.gestionTurnosOperariosBusinessList = [];
        }
      })
    },
      cambioHora(dates) {
         this.datefrom = dates[0];
         this.dateto = dates[1];
      },
      // initChart() {
      //    if (!this.workerDataByUser || this.workerDataByUser.length === 0) {
      //       if (this.objectChart) {
      //          this.objectChart.destroy();
      //          this.objectChart = null;
      //       }
      //       return;
      //    }

      //    const labels = this.workerDataByUser.map(worker => `${worker.name} ${worker.surName}`);
      //    // Convertir segundos a horas con decimales
      //    const data = this.workerDataByUser.map(worker => {
      //       const hours = Math.floor(worker.totalSecondsWorked / 3600);
      //       const minutes = Math.floor((worker.totalSecondsWorked % 3600) / 60);
      //       return hours + minutes / 100;
      //    });

      //    const randomColor = require("randomcolor");
      //    const colors = randomColor({
      //       luminosity: "dark",
      //       count: labels.length,
      //       format: "rgb",
      //    });

      //    const backgroundColors = colors.map(x => {
      //       const xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
      //       return `rgba(${xcolors[0]},${xcolors[1]},${xcolors[2]}, 0.6)`;
      //    });
      //    const borderColors = colors.map(x => {
      //       const xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
      //       return `rgba(${xcolors[0]},${xcolors[1]},${xcolors[2]}, 0.3)`;
      //    });
      //    const hoverBackgroundColors = colors.map(x => {
      //       const xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
      //       return `rgba(${xcolors[0]},${xcolors[1]},${xcolors[2]}, 1)`;
      //    });

      //    if (this.objectChart) {
      //       this.objectChart.destroy();
      //    }
      //    this.objectChart = new Chart("chart", {
      //       type: "bar",
      //       data: {
      //          labels: labels,
      //          datasets: [
      //             {
      //                label: this.$t("horasTrabajadas"),
      //                data: data,
      //                backgroundColor: backgroundColors,
      //                borderColor: borderColors,
      //                hoverBackgroundColor: hoverBackgroundColors,
      //                borderWidth: 1,
      //             },
      //          ],
      //       },
      //       options: {
      //          scales: {
      //             yAxes: [
      //                {
      //                   ticks: {
      //                      beginAtZero: true,
      //                   },
      //                },
      //             ],
      //          },
      //          responsive: true,
      //          maintainAspectRatio: false,
      //       },
      //    });
      // },
      // Nombre
      sortedArrayNombreASC() {
         this.workerDataByUser.sort((a, b) => {
            const nameA = (a.name + ' ' + a.surName).toLowerCase();
            const nameB = (b.name + ' ' + b.surName).toLowerCase();
            return nameA.localeCompare(nameB);
         });
         this.ordenarNombre = 1;
         this.ordenarHoras = 0;
         this.ordenarBarcode = 0;
      },

      sortedArrayNombreDESC() {
         this.workerDataByUser.sort((a, b) => {
            const nameA = (a.name + ' ' + a.surName).toLowerCase();
            const nameB = (b.name + ' ' + b.surName).toLowerCase();
            return nameB.localeCompare(nameA);
         });
         this.ordenarNombre = 0;
         this.ordenarHoras = 0;
         this.ordenarBarcode = 0;
      },

      // Horas
      sortedArrayHorasASC() {
         this.workerDataByUser.sort((a, b) => a.totalSecondsWorked - b.totalSecondsWorked);
         this.ordenarHoras = 1;
         this.ordenarNombre = 0;
         this.ordenarBarcode = 0;
      },

      sortedArrayHorasDESC() {
         this.workerDataByUser.sort((a, b) => b.totalSecondsWorked - a.totalSecondsWorked);
         this.ordenarHoras = 0;
         this.ordenarNombre = 0;
         this.ordenarBarcode = 0;
      },

      // Barcode
      sortedArrayBarcodeASC() {
         this.workerDataByUser.sort((a, b) => a.barCode.localeCompare(b.barCode));
         this.ordenarBarcode = 1;
         this.ordenarNombre = 0;
         this.ordenarHoras = 0;
      },

      sortedArrayBarcodeDESC() {
         this.workerDataByUser.sort((a, b) => b.barCode.localeCompare(a.barCode));
         this.ordenarBarcode = 0;
         this.ordenarNombre = 0;
         this.ordenarHoras = 0;
      },

      emitirConsulta(filtrarPorFecha) {
         this.getWorkersShifts(filtrarPorFecha);
      },

      sortedArrayWorkerDay: function () {
         function compare(a, b) {
            if (a.initDate < b.initDate) return -1;
            if (a.initDate > b.initDate) return 1;
            return 0;
         }

         return this.listTurnos.sort(compare);
      },

      showDesgloseHoras() {
         this.$modal.show("modal-desglose-horas");
      },

      hideDesgloseHoras() {
         this.$modal.hide("modal-desglose-horas");
      },

      getDesgloseHorasByWorker(idWorker) {
         const config = {
            params: {
               jwt: this.$store.getters.jwt,
               idWorker: idWorker,
               ids: this.negociosFiltrados,
               datefrom: moment(this.datefrom).startOf("day").unix(),
               dateto: moment(this.dateto).endOf("day").unix(),
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
         };

         let vm = this;
         this.axios
            .get(this.$store.getters.apiUrl + "turnos/getDesgloseHorasByWorker", config)
            .then(function (response) {
               vm.desgloseHoras = response.data.result; // resultado de la API
               vm.$modal.show("modal-desglose-horas");  // abrir modal
            })
            .catch(function (error) {
               console.error(error);
            });
      },

      getWorkersShifts() {
         var config = {
            params: {
               jwt: this.$store.getters.jwt,
               ids: this.negociosFiltrados,
               filtrarFecha: this.filtrarPorFecha,
               datefrom: moment(this.datefrom)
                  .startOf("day")
                  .unix(),
               dateto: moment(this.dateto)
                  .endOf("day")
                  .unix(),
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
         };

         let vm = this;
         this.axios
            .get(this.$store.getters.apiUrl + "turnos/getWorkersShifts", config)
            .then(function (response) {
               vm.workerDataByUser = response.data.result;
            })
            .catch(function (error) {
               console.log(error);
            })
            .finally((_) => {
               this.loading.close();
            });
      },

      exportGestionTurnosOperariosExcel(workerIds) {
         const ids = Array.isArray(workerIds) ? workerIds.join(",") : workerIds;
         window.location.href =
            this.$store.getters.apiUrl +
            "/workers/exportRegistroHorarioByUser/Excel?" +
            "idWorkers=" + ids +
            "&datefrom=" +
            moment(this.datefrom).startOf("day").unix() +
            "&dateto=" +
            moment(this.dateto).endOf("day").unix() +
            "&jwt=" + this.$store.getters.jwt;
      },

      exportGestionTurnosOperariosPDF(idWorker) {
         window.location.href =
            this.$store.getters.apiUrl +
            "/workers/exportRegistroHorarioByBusiness/PDF?idBusiness=" +
            this.idBusiness +
            "&datefrom=" +
            moment(this.datefrom)
               .startOf("day")
               .unix() +
            "&idWorker=" +
            idWorker +
            "&dateto=" +
            moment(this.dateto)
               .endOf("day")
               .unix() +
            "&jwt=" +
            this.$store.getters.jwt;
      },
   },
};
</script>

<style scoped>
a li {
   color: #111;
}

.card {
   padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Operarios/GestionTurnosOperario.vue